import { render, staticRenderFns } from "./RouteInfo.vue?vue&type=template&id=196e5c34"
import script from "./RouteInfo.vue?vue&type=script&lang=js"
export * from "./RouteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports